import {
    Box,
    Button,
    TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Content = styled(Box)`
    display: flex;
    padding: 1%;
    flex-wrap: wrap;
    justify-content: center;
`;

const Campo = styled(TextField)`
    margin: 1vh 0 1vh 0;
`;

const ButtonGerar = styled(Button) <any>`
  color: ${props => props.disabled ? 'unset' : 'green !important'};
  float: right;
  margin-top: auto;
`;

const Panel = styled('div')`
    min-width: 400px;
`;

const BoxButtons = styled('div')`
    display: flex;
`

const IdentificacaoSection = styled('section')`
    p {
        font-size: 12px; /* ajuste o tamanho que quiser */
        line-height: 1.5; /* opcional, deixa mais legível */
    }
`

export { Content, Campo, ButtonGerar, Panel, BoxButtons, IdentificacaoSection };